__turbopack_context__.v({
  "container": "styles-module-scss-module__H3pF9q__container",
  "form": "styles-module-scss-module__H3pF9q__form",
  "header": "styles-module-scss-module__H3pF9q__header",
  "name": "styles-module-scss-module__H3pF9q__name",
  "submit": "styles-module-scss-module__H3pF9q__submit",
  "textBlock": "styles-module-scss-module__H3pF9q__textBlock",
});
